module.exports = __webpack_public_path__ + "img/right-more-5.9ea010ef.png";